import React from "react";
import type { MerchantFollow } from "../Components/Layouts/LayoutPrice";

const MerchantFollowContext = React.createContext<MerchantFollow[]>([]);

export const MerchantFollowProvider = MerchantFollowContext.Provider;
export const useMerchantFollow = () => React.useContext(MerchantFollowContext);
